import { render, staticRenderFns } from "./ResalesStocks.vue?vue&type=template&id=075e2db4"
import script from "./ResalesStocks.vue?vue&type=script&lang=js"
export * from "./ResalesStocks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports